export const OTP = "OTP";

const initialState = {
    phoneNumber: null,
    otp: null,
    generated: null,
    attemptsLeft: null,
    verified: false,
    genError: false,
    verifEror: false,
}

export default (state = initialState, action) => {
    switch (action.type) {
        case OTP:
            return {...state, ...action.payload};
        default:
            return state;
    }
}
